import React from "react";
import PropTypes from "prop-types";
import BurgerMenuCategoryMenu from "web/react/components/burger-menu/burger-menu-category-menu/burger-menu-category-menu";

function BurgerMenuView({ categories, onBackToMainClick, onCategoryClick, selectedCategory }) {
    return (
        <React.Fragment>
            {categories &&
                categories.map((category) => {
                    const subMenus = category.menus ? category.menus : category.links;
                    return (
                        <>
                            <div
                                style={{
                                    display: selectedCategory === category ? "initial" : "none",
                                }}
                            >
                                <BurgerMenuCategoryMenu
                                    key={category.display_name + "burger"}
                                    selectedCategory={category.display_name || category.name}
                                    onCategoryClick={onCategoryClick}
                                    onBackToMainClick={onBackToMainClick}
                                    category={category}
                                />
                            </div>
                            <BurgerMenuView
                                key={category.display_name + "menus"}
                                categories={subMenus}
                                onCategoryClick={onCategoryClick}
                                onBackToMainClick={onBackToMainClick}
                                selectedCategory={selectedCategory}
                            />
                            <BurgerMenuView
                                key={category.display_name + "trends"}
                                categories={category.trend_menus}
                                onBackToMainClick={onBackToMainClick}
                                onCategoryClick={onCategoryClick}
                                selectedCategory={selectedCategory}
                            />
                        </>
                    );
                })}
        </React.Fragment>
    );
}

export default BurgerMenuView;

BurgerMenuView.propTypes = {
    categories: PropTypes.array,
    onBackToMainClick: PropTypes.func.isRequired,
    onCategoryClick: PropTypes.func.isRequired,
    selectedCategory: PropTypes.object,
};
